import axios from "axios";
import { REACT_APP_API } from "../constants";
import { requestsFor } from "./headerService";

// Database install credentials (PROXY_CLIENT_ID / PROXY_CLIENT_SECRET in db.env).
// The org always comes from the session: never send orgId.
const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API}/api/v1/databaseService`,
});

const requests = requestsFor(axiosInstance);

const path = {
  issue: "/proxy/credentials",
  list: "/proxy/credentials/list",
  revoke: "/proxy/credentials/revoke",
};

/** Plain message from an API error, for the UI. Never includes the request body. */
export const credentialErrorMessage = (error, fallback) => {
  const status = error?.response?.status;
  if (status === 403) return "Only admins can manage install credentials.";
  return error?.response?.data?.error || fallback;
};

/**
 * Issue one credential for an install. Resolves { clientId, clientSecret }.
 * The secret is returned once: callers put it in db.env and drop it.
 */
export async function issueProxyCredential(label) {
  const { data } = await requests.post(path.issue, { label: String(label || "").trim() });
  if (!data?.clientId || !data?.clientSecret) {
    throw new Error("The server did not return an install credential.");
  }
  return { clientId: data.clientId, clientSecret: data.clientSecret };
}

/** [{ id, tenantId, label, clientId, createdAt, lastUsedAt?, revokedAt? }], newest first. */
export async function listProxyCredentials() {
  const { data } = await requests.post(path.list, {});
  return Array.isArray(data?.data) ? data.data : [];
}

export async function revokeProxyCredential(id) {
  const { data } = await requests.post(path.revoke, { credentialId: Number(id) });
  return data;
}
